import React, { FC, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { ExerciseModal } from "../../../../models/ExerciseModal/Exercise.model";
import excerciseService from "../../../../services/ExcerciseService/excercise.service";
import AppHeader from "../../../../shared/components/AppHeader";
import { SwitchTabs } from "../../../../shared/components/SwitchTabs";
import ExercisesCardsAnalytics from "../ExerciseCardsAnalytics";

const ListAnalyticsExerciseCards: FC = () => {
  const { state }: { state: any } = useLocation();
  const [exercises, setExercises] = useState<any[]>([]);
  const [selected, setSelected] = useState<number>(0);
  useEffect(() => {
   
    fetchExercises()
  }, []);
  const fetchExercises = () => {
    excerciseService.getExcerciseByFilter(
        {
            chaptor_id: state.chapterId,
        },
        (exercises: ExerciseModal[]) => {
            setExercises(exercises);
        },
        () => {}
    );
  };
  
  return (
    <div className="page-view">
     <AppHeader
        headerText={state?.chapterName}
        showSearch={false}
        showButton={false}
        showBreadCrumb={false}
        showFilter={false}
        buttonIcon={null}
        showBack
      />
    <SwitchTabs defaultSelected={0} onSelect={(index) => setSelected(index)} tabs={["Exercise", "Quick Quiz"]}/>
     {
        !selected ?  <ExercisesCardsAnalytics exercises={exercises} /> :  <ExercisesCardsAnalytics exercises={exercises.length > 1 ? exercises.slice(0, 1) : exercises} />
     } 
    </div>
  );
};
export default ListAnalyticsExerciseCards;
